import React from 'react';
import { NostoTagging } from './Provider';
const NostoProduct = ({ promise, data, elementClicked }) => (React.createElement(NostoTagging, { id: "product", promise: promise, data: data, elementClicked: elementClicked }, data => {
    if (data) {
        // Required data
        const { productId, name, url, imageUrl, availability, price, currencyCode, categories } = data;
        // Optional data
        const { brand, description, googleCategory, datePublished, listPrice, tag1, tag2, tag3, ratingValue, reviewCount, alternateImageUrls, customFields } = data;
        return (React.createElement("div", { style: { display: 'none' } },
            React.createElement("div", { className: "nosto_page_type" }, "product"),
            React.createElement("div", { className: "nosto_product" },
                React.createElement("span", { className: "product_id" }, productId),
                React.createElement("span", { className: "name" }, name),
                React.createElement("span", { className: "url" }, url),
                React.createElement("span", { className: "image_url" }, imageUrl),
                React.createElement("span", { className: "availability" }, availability),
                React.createElement("span", { className: "price" }, price),
                React.createElement("span", { className: "price_currency_code" }, currencyCode),
                categories.map((category) => (React.createElement("span", { className: "category", key: category }, category))),
                brand && React.createElement("span", { className: "brand" }, brand),
                description && (React.createElement("span", { className: "description" }, description)),
                googleCategory && (React.createElement("span", { className: "google_category" }, googleCategory)),
                datePublished && (React.createElement("span", { className: "date_published" }, datePublished)),
                listPrice && React.createElement("span", { className: "list_price" }, listPrice),
                ratingValue && (React.createElement("span", { className: "rating_value" }, ratingValue)),
                reviewCount && (React.createElement("span", { className: "review_count" }, reviewCount)),
                tag1 &&
                    tag1.map((tag) => (React.createElement("span", { className: "tag1", key: tag }, tag))),
                tag2 &&
                    tag2.map((tag) => (React.createElement("span", { className: "tag2", key: tag }, tag))),
                tag3 &&
                    tag3.map((tag) => (React.createElement("span", { className: "tag3", key: tag }, tag))),
                alternateImageUrls &&
                    alternateImageUrls.map((url, index) => (React.createElement("span", { key: index, className: "alternate_image_url" }, url))),
                customFields && (React.createElement("span", { className: "custom_fields" }, Object.entries(customFields).map(([key, value]) => (React.createElement("span", { className: key, key: key }, value))))))));
    }
    else {
        return null;
    }
}));
export default NostoProduct;
//# sourceMappingURL=Product.js.map